import {ApiRequestStates} from '../../const'

import {reducer} from '../helpers'

import {ShowroomData} from '../../typedefs/showrooms'

import {ShowroomDetailAction, ShowroomDetailActionName} from '../../actions/showrooms/detail'

export interface ShowroomDetailState {
  error: string | null
  location: ShowroomData | null
  requestState: string // TODO this can get tightened up once ApiRequestStates is TypeScripted
}

const initialState: ShowroomDetailState = {
  error: null,
  location: null,
  requestState: ApiRequestStates.IDLE,
}

export default reducer(
  initialState,
  (
    state: ShowroomDetailState,
    action: ShowroomDetailAction,
  ): Partial<ShowroomDetailState> | null => {
    switch (action.type) {
      case ShowroomDetailActionName.init:
        return initialState
      case ShowroomDetailActionName.failure:
        return {
          location: null,
          error: action.payload,
          requestState: ApiRequestStates.ERROR,
        }
      case ShowroomDetailActionName.pending:
        return {
          requestState: ApiRequestStates.PENDING,
        }
      case ShowroomDetailActionName.success:
        return {
          location: action.payload,
          error: null,
          requestState: ApiRequestStates.SUCCESS,
        }
      default:
        return null
    }
  },
)
